import { useCallback, useEffect, useRef, useState } from "react";

const useAutoHideControls = (isPlaying, delay) => {
  const timerRef = useRef(null);
  const [showControls, setShowControls] = useState(true);

  const clearTimer = useCallback(() => {
    if (timerRef.current !== null) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  const resetControls = useCallback(() => {
    clearTimer();
    setShowControls(true);
  }, [clearTimer]);

  useEffect(() => {
    clearTimer();

    if (!isPlaying) return clearTimer;

    timerRef.current = setTimeout(() => {
      setShowControls(false);
      timerRef.current = null;
    }, delay);

    return clearTimer;
  }, [clearTimer, delay, isPlaying]);

  return [showControls, resetControls];
};

export default useAutoHideControls;
